<template>
  <div class="product-tile">
    {{product.title}}
  </div>
</template>

<script>

export default {
  name: "ProductTile",
  components: {
  },
  props: {
    product : Object
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  computed: {
  },
  emits: [],
  watch: {},
  methods: {
  }
};
</script>
